export enum CollectionTypeCode {
    FDT = 'FDT',
    RAP = 'RAP'
}
